export default __webpack_public_path__ + "static/media/continue.863b6b72.png";